<!-- @veltra/icons generated sha256:1d6e6fc8dfcbe141 gen:8 source:src/svg/normal/logout.svg -->
<script setup lang="ts">
defineOptions({ name: 'Logout' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M9 4.49V3H2v10h7v-1.49a.51.51 0 0 1 .496-.51c.276 0 .504.217.504.493V13.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2.007A.496.496 0 0 1 9.504 5 .51.51 0 0 1 9 4.49m4.477 3.01-1.9-1.901a.477.477 0 0 1-.002-.688l.008-.008a.5.5 0 0 1 .708-.003l2.747 2.746a.5.5 0 0 1 0 .708L12.291 11.1a.5.5 0 0 1-.708-.003l-.008-.008a.477.477 0 0 1 .001-.688L13.477 8.5H6.498A.486.486 0 0 1 6 8.015v-.011c0-.276.222-.504.498-.504z"
    />
  </svg>
</template>
